import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";
import Swal from "sweetalert2";

const Account = () => {
  //toast
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 2000,
  });

  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [registeredEmail, setRegisteredEmail] = useState("");

  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const initialState = {
    first_name: "",
    last_name: "",
    image: "",
    phone: "",
    username: "",
    email: "",
    password: "",
    type: "customer",
    status: "Active",
  };

  const [formData, setFormData] = useState(initialState);
  const [profileData, setProfileData] = useState(initialState);
  const API_URL = process.env.REACT_APP_API_URL;

  // ----------- validate fields -----------
  const validateRegisterFields = () => {
    // First name
    if (!/^[A-Za-z ]+$/.test(formData.first_name)) {
      Swal.fire({
        icon: "error",
        title: "Invalid First Name",
        text: "Only letters allowed.",
      });
      return false;
    }

    // Last name
    if (!/^[A-Za-z ]+$/.test(formData.last_name)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Last Name",
        text: "Only letters allowed.",
      });
      return false;
    }

    // Username (no spaces)
    if (formData.username.includes(" ")) {
      Swal.fire({
        icon: "error",
        title: "Invalid Username",
        text: "Username cannot contain spaces.",
      });
      return false;
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.",
      });
      return false;
    }

    // Phone – only digits, 10 digits exactly
    if (!/^[0-9]{10}$/.test(formData.phone)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Phone Number",
        text: "Phone must be exactly 10 digits.",
      });
      return false;
    }

    // Password minimum 6 chars (customize if needed)
    if (formData.password.length < 6) {
      Swal.fire({
        icon: "error",
        title: "Weak Password",
        text: "Password must be at least 6 characters.",
      });
      return false;
    }

    return true;
  };

  // ----------- Image Chng Handle -----------
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   setSelectedImage(file);

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviewImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedImage(file);

    // Show preview
    const imageUrl = URL.createObjectURL(file);
    setPreviewImage(imageUrl);
  };

  // Img Uploading
  // const uploadToHostinger = async (file) => {
  //   if (!file) return null;

  //   const formData = new FormData();
  //   formData.append("media[]", file);

  //   try {
  //     const res = await axios.post(
  //       "https://orangered-rat-360569.hostingersite.com/api/addFiles",
  //       formData,
  //       { headers: { "Content-Type": "multipart/form-data" } }
  //     );

  //     const uploadedName = res.data.urls[0];
  //     return `https://orangered-rat-360569.hostingersite.com/storage/app/public/files/${uploadedName}`;
  //   } catch (err) {
  //     console.error("Image upload failed:", err);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Upload Failed!",
  //       text: "Image upload failed. Please try again.",
  //     });
  //     return null;
  //   }
  // };

  const uploadToS3 = async (file) => {
    if (!file) return null;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/upload/single`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return res.data.fileUrl; // <- S3 URL
    } catch (err) {
      console.error("S3 upload failed:", err);
      return null;
    }
  };

  //  Password hide-Unhide
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        const res = await axios.get(`${API_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data?.user) {
          setIsAuthenticated(true);
          setProfileData({
            first_name: res.data.user.first_name || "",
            last_name: res.data.user.last_name || "",
            image: res.data.user.image || "",
            username: res.data.user.username || "",
            phone: res.data.user.phone || "",
            email: res.data.user.email || "",
            password: "",
            type: res.data.user.type || "customer",
            status: res.data.user.status || "Active",
          });
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        localStorage.removeItem("authToken");
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [API_URL]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  };

  //  REGISTER FUNCTION
  // const handleRegister = async (e) => {
  //   e.preventDefault();
  //   if (!validateRegisterFields()) return;
  //   try {
  //     let uploadedImage = null;

  //     if (selectedImage) {
  //       uploadedImage = await uploadToS3(selectedImage);
  //       console.log(uploadedImage);
  //       if (!uploadedImage) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Upload Failed!",
  //           text: "Image upload failed. Please try again.",
  //         });
  //         return;
  //       }
  //     }

  //     const payload = {
  //       ...formData,
  //       image: uploadedImage,
  //     };

  //     const res = await axios.post(`${API_URL}/auth/register`, payload);

  //     if (res.data?.message?.includes("OTP sent")) {
  //       setRegisteredEmail(formData.email);
  //       setShowOtp(true);
  //       Swal.fire({
  //         icon: "info",
  //         title: "OTP Sent!",
  //         text: "Check your email to complete registration.",
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Registration Failed",
  //         text: res.data?.message || "Something went wrong!",
  //       });
  //     }
  //   } catch (err) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Registration Failed",
  //       text: err.response?.data?.message || "Something went wrong!",
  //     });
  //   }
  // };
  const handleRegister = async (e) => {
    e.preventDefault();

    if (!validateRegisterFields()) return;

    try {
      let uploadedImage = null;

      if (selectedImage) {
        uploadedImage = await uploadToS3(selectedImage);

        if (!uploadedImage) {
          Swal.fire({
            icon: "error",
            title: "Upload Failed!",
            text: "Image upload failed. Please try again.",
          });
          return;
        }
      }

      const payload = {
        ...formData,
        image: uploadedImage || "", // S3 URL
      };

      const res = await axios.post(`${API_URL}/auth/register`, payload);

      if (res.data?.message?.includes("OTP sent")) {
        setRegisteredEmail(formData.email);
        setShowOtp(true);

        Swal.fire({
          icon: "info",
          title: "OTP Sent!",
          text: "Check your email to complete registration.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: res.data?.message || "Something went wrong!",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: err.response?.data?.message || "Something went wrong!",
      });
    }
  };

  //  VERIFY OTP FUNCTION
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_URL}/auth/verify-otp`, {
        email: registeredEmail || formData.email,
        otp: `${otp}`,
      });
      if (res.data.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Email Verified!",
          text: "You can now login to your account.",
        });
        setShowOtp(false);
        setFormData(initialState);
        setIsLogin(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid OTP",
          text: res.data?.message || "Please try again.",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: err.response?.data?.message || "Something went wrong!",
      });
    }
  };

  //  LOGIN FUNCTION
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_URL}/auth/login`, {
        email: formData.username,
        password: formData.password,
      });

      const token = res.data?.token;
      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Login Error",
          text: "No token received from server!",
        });
        return;
      }

      localStorage.setItem("authToken", token);
      localStorage.setItem("userId", res.data.user._id);

      // CART SYNC (ORIGINAL LOGIC PRESERVED)
      const guestCart = JSON.parse(localStorage.getItem("cart")) || [];

      if (guestCart.length > 0) {
        // Guest cart exists → merge with backend
        const formattedCart = guestCart.map((item) => ({
          id: item.id,
          qty: item.qty,
        }));

        try {
          const syncRes = await axios.post(
            `${API_URL}/cart/sync`,
            { cart: formattedCart },
            { headers: { Authorization: `Bearer ${token}` } },
          );

          if (syncRes.data?.cart) {
            const mergedCart = syncRes.data.cart.map((i) => ({
              id: i.product._id,
              name: i.product.name,
              price: i.price,
              qty: i.qty,
              images: i.product.images,
            }));

            localStorage.setItem("cart", JSON.stringify(mergedCart));
          }
        } catch (syncErr) {
          console.error("Cart sync failed:", syncErr);
        }
      } else {
        try {
          const cartRes = await axios.get(`${API_URL}/cart/`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const dbCart = cartRes.data.cart || [];

          // Map properly for frontend & localStorage
          const mappedCart = dbCart.map((item) => ({
            id: item.product._id,
            name: item.product.name,
            price: item.price,
            qty: item.qty,
            images: item.product.images,
          }));

          localStorage.setItem("cart", JSON.stringify(mappedCart));
        } catch (fetchErr) {
          console.error("Fetching DB cart failed:", fetchErr);
          localStorage.setItem("cart", JSON.stringify([]));
        }
      }

      Toast.fire({
        icon: "success",
        title: "Login Successful!",
      });
      navigate("/user");

      // Reset form
      setFormData(initialState);
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: "Invalid email or password.",
      });
    }
  };

  // UPDATE PROFILE FUNCTION
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");

    try {
      const updateData = {
        first_name: profileData.first_name,
        last_name: profileData.last_name,
        username: profileData.username,
        email: profileData.email,
      };

      // Only include password if it's not empty
      if (profileData.password) {
        updateData.password = profileData.password;
      }

      await axios.put(`${API_URL}/auth/profile`, updateData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: "Profile Updated!",
        text: "Your profile changes have been saved.",
      });

      // Clear password field after update
      setProfileData({ ...profileData, password: "" });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data?.message || "Could not update profile.",
      });
    }
  };

  if (isLoading) {
    return (
      <section className="account py-80">
        <div className="container container-lg">
          <div className="row justify-center">
            <div className="col-xl-6">
              <div className="text-center py-40">
                <p className="text-lg">Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row justify-center">
          <div className="col-xl-6">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
              {isLogin ? (
                <>
                  <h6 className="text-xl mb-32">Login</h6>
                  <form onSubmit={handleLogin}>
                    <div className="mb-24">
                      <label
                        htmlFor="username"
                        className="text-neutral-900 text-lg mb-8 fw-medium"
                      >
                        Username or email address{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        placeholder="Enter Username or Email"
                        required
                      />
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="password"
                        className="text-neutral-900 text-lg mb-8 fw-medium"
                      >
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="common-input"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter Password"
                        required
                      />
                    </div>
                    <div className="mb-24 mt-48">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                      >
                        Log in
                      </button>
                    </div>
                  </form>
                  <div className="mt-32 flex flex-row justify-between gap-12">
                    <p className="text-gray-600 text-sm">
                      Forgot your password?{" "}
                      <button
                        type="button"
                        className="text-main-600 fw-semibold hover-text-decoration-underline"
                        onClick={() => navigate("/forgot-password")}
                      >
                        Reset here
                      </button>
                    </p>

                    <p className="text-gray-600 text-sm">
                      Don't have an account?{" "}
                      <button
                        type="button"
                        className="text-main-600 fw-semibold hover-text-decoration-underline"
                        onClick={() => setIsLogin(false)}
                      >
                        Register here
                      </button>
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <h6 className="text-xl mb-32">Register</h6>
                  <form onSubmit={handleRegister}>
                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        Profile Image
                      </label>

                      {previewImage && (
                        <img
                          src={previewImage}
                          alt="Preview"
                          className="w-90 h-90 rounded-full object-cover mb-12 border mx-auto"
                        />
                      )}

                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="common-input"
                      />
                    </div>

                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input"
                        name="first_name"
                        placeholder="Enter First Name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input"
                        name="last_name"
                        placeholder="Enter Last Name"
                        value={formData.last_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        Username <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input"
                        name="username"
                        placeholder="Enter Username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="common-input"
                        name="email"
                        placeholder="Enter Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-24">
                      <label className="text-neutral-900 text-lg mb-8 fw-medium">
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="common-input"
                        name="password"
                        placeholder="Enter Password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-main py-18 px-40 mt-16"
                    >
                      Register
                    </button>
                  </form>

                  {showOtp && (
                    <div className="mt-32">
                      <h6 className="text-lg mb-16">Enter OTP</h6>
                      <form onSubmit={handleVerifyOtp}>
                        <input
                          type="text"
                          className="common-input mb-16"
                          placeholder="Enter the OTP sent to your email"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          required
                        />
                        <button
                          type="submit"
                          className="btn btn-main py-18 px-40"
                        >
                          Verify OTP
                        </button>
                      </form>
                    </div>
                  )}

                  <div className="mt-32 flex flex-col gap-12">
                    <p className="text-gray-600 text-sm">
                      Already have an account?{" "}
                      <button
                        type="button"
                        className="text-main-600 fw-semibold hover-text-decoration-underline"
                        onClick={() => setIsLogin(true)}
                      >
                        Login here
                      </button>
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Account;
